import React, { useState } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

import Header from "./Navigation/Header";
import Footer from "./Footer/Footer";

const Layout = ({
  children,
  headerStyle,
  hideHeader,
  hideFooter,
  backgroundColor,
  customTheme,
  noHeaderBottomSpacing,
  marginTop,
}) => {
  const [bodyOffset, setBodyOffset] = useState(0);
  return (
    <div>
      <Helmet>
        <script type="application/ld+json">{`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '3480503132080468');
          fbq('track', 'PageView');
        `}</script>
        {/* <script type="text/javascript">
          {`
            (function (w, d, s, u, wid, id, tid, dm) {
                w.mxq = w.mxq || [];
                w.mxq.push({ wid: wid, id: id, tid: tid, dm: dm });
                var js, fjs = d.getElementsByTagName(s)[0];
                js = d.createElement(s);
                js.async = true;
                js.src = u + "?t=" + new Date().getTime();
                fjs.parentNode.insertBefore(js, fjs);
            })(window, document, "script", "https://maximise.nyc3.cdn.digitaloceanspaces.com/pixel.min.js", "RMieIJj0M7RIDmr7", "aWOCLlt_fu0-a032i37n", "6767015b3c059cce7ba27bd1", ["RealSynch.com"]);
          `}
        </script> */}
      </Helmet>
      <Header
        headerStyle={headerStyle}
        hideHeader={hideHeader}
        setBodyOffset={setBodyOffset}
        customTheme={customTheme}
        noHeaderBottomSpacing={noHeaderBottomSpacing}
      />
      <main
        id="body-content"
        style={{
          marginTop: marginTop,
          paddingTop: bodyOffset + "px",
          backgroundColor: backgroundColor,
        }}
        className="overflow-x-hidden lg:!mt-0"
      >
        {children}
      </main>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src="https://www.facebook.com/tr?id=3480503132080468&ev=PageView&noscript=1"
        />
      </noscript>
      <Footer hideFooter={hideFooter} />
    </div>
  );
};

Layout.propTypes = {
  headerStyle: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Layout;
